import { Challenge } from './Challenge';

export default Challenge;
